var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"x-axis",attrs:{"transform":("translate(0, " + (_vm.c.xAxisPosition === 'bottom'
      ? _vm.p.scaleY(_vm.p.minY)
      : _vm.c.legendPosition === 'top'
      ? +_vm.c.globalMarginTop + +_vm.c.legendHeight
      : +_vm.c.globalMarginTop) + ")")}},_vm._l((_vm.p.ticksX),function(datum,index){return _c('g',{key:index},[_c('line',{class:[
        'x-axis-tick',
        {
          selected:
            _vm.p.tooltipMove &&
            _vm.p.tooltipMove.datum &&
            _vm.p.tooltipMove.datum[_vm.c.xAxis] == datum,
        } ],style:({
        stroke: _vm.c.xAxisTickStrokeColor,
        strokeWidth: _vm.c.xAxisTickStrokeWidth,
      }),attrs:{"x1":_vm.p.scaleX(datum),"x2":_vm.p.scaleX(datum),"y1":_vm.c.xAxisPosition === 'top' ? _vm.c.xAxisHeight : 0,"y2":_vm.c.xAxisPosition === 'top'
          ? _vm.c.xAxisHeight - +_vm.c.xAxisTickHeight
          : +_vm.c.xAxisTickHeight}}),_c('text',{class:[
        'x-axis-label',
        {
          selected:
            _vm.p.tooltipMove &&
            _vm.p.tooltipMove.datum &&
            _vm.p.tooltipMove.datum[_vm.c.xAxis] == datum,
        },
        {
          overlapped: _vm.checkLabelOverlap(index, datum),
        } ],style:({ fontSize: _vm.c.xAxisFontSize }),attrs:{"x":_vm.p.scaleX(datum),"y":_vm.c.xAxisPosition === 'bottom' ? +_vm.c.xAxisHeight : +_vm.c.xAxisFontSize,"text-anchor":"middle","fontSize":_vm.c.xAxisFontSize}},[_vm._v(" "+_vm._s(datum)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }